<template>
  <div id="app">
    <PrivateHeader v-if="isLoggedIn" :artistMode="browseAsArtist" />
    <PublicHeader v-else />

    <b-container class="root-container" :fluid="fluidPage">
      <b-row class="root-row">
        <Sidebar v-if="showSidebar" :artistMode="browseAsArtist"></Sidebar>
        <b-col class="router-content">
          <transition name="flash-message-fade">
            <FlashMessage v-if="flashMessage" :message="flashMessage" />
          </transition>
          <router-view />
        </b-col>
      </b-row>
    </b-container>

    <Footer :class="footerClass" />
    <MiniPlayer />

    <div id="dacast-hidden-player-wrapper" />
    <div id="dacast-temp-player" />

    <b-modal id="modalMessage"
             ref="modalMessage"
             class="no-decorations"
             title="Please wait ..."
             no-close-on-esc no-close-on-backdrop hide-header-close centered>
      <div class="content">
        <font-awesome-icon icon="spinner" size="lg" spin />
        <br>
        {{ modalMessage }}
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import MiniPlayer from './components/widgets/MiniPlayer'
import PublicHeader from './components/widgets/PublicHeader'
import PrivateHeader from './components/widgets/PrivateHeader'
import Footer from './components/widgets/Footer'
import Sidebar from '@/components/widgets/Sidebar'
import FlashMessage from '@/components/widgets/FlashMessage'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'App',
  components: {
    MiniPlayer,
    PublicHeader,
    PrivateHeader,
    Footer,
    Sidebar,
    FlashMessage,
    FontAwesomeIcon
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('profile', ['isArtist']),
    ...mapGetters('flash', ['flashMessage', 'modalMessage']),
    browseAsArtist () {
      return this.$route.meta.requireUserType === 'artist' && this.isArtist
    },
    fluidPage () {
      return !!this.$route.meta.fluidPage
    },
    footerClass () {
      return this.fluidPage ? '' : 'mt-3'
    },
    showSidebar () {
      return this.isLoggedIn && !this.$route.meta.hideSidebar
    }
  },
  watch: {
    modalMessage (val) {
      if (val) {
        this.$refs.modalMessage.show()
      } else {
        this.$refs.modalMessage.hide()

        // If the modal is removed too fast after showing, it may not remove it, so try to cleanup afterwards if
        // needed
        setTimeout(() => {
          this.$refs.modalMessage.hide()
        }, 200)
      }
    }
  },
  created () {
    this.$store.dispatch('social/init')

    if (this.isLoggedIn) {
      this.$store.dispatch('profile/getCurrentUser')
      this.$store.dispatch('realtime/initNotifications')
      this.$store.dispatch('profile/listFollowedArtists')
    }
  }
}
</script>

<style lang="scss">
  #app {
    margin-top: 48px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .root-container {
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      &.container {
        width: 100% !important;
        /* max-width: 1140px !important; */
        max-width: 1336px !important;
        /* margin-top: 36px; */
      }

      .root-row {
        flex-grow: 1;
        align-items: start;

        .router-content {
          align-self: stretch;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          margin-bottom: 48px;
        }
      }
    }
  }

  #dacast-hidden-player-wrapper {
    display: none;
  }

  #modalMessage .content {
    text-align: center;
    font-size: 1.2em;
    line-height: 2em;
  }

  .flash-message-fade-enter-active {
    transition: opacity .5s;
  }
  .flash-message-fade-leave-active {
    transition: opacity 2s;
  }

  .flash-message-fade-enter, .flash-message-fade-leave-to {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue